import LandingPage from './Pages/LandingPage/LandingPage'
import './App.css';
import ScrollToTop from './Components/ScrollToTop/ScrollToTop';

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";


function App() {

  return (
    
    <div className="App">
       <Router>
              <ScrollToTop>
                <Routes>
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/Landing" element={<LandingPage />} />


                    
                </Routes>
              </ScrollToTop>
            </Router>
      
      </div>
  );
}

export default App;